<template>
  <!-- Content Wrapper. Contains page content -->

  <div>
    <div
      style="display: flex; justify-content: center; flex-direction: column"
      class="app"
    >
      <br />

      <button
        :style="{
          alignItems: 'center',
          marginTop: '5px',
          marginBottom: '5px',
          backgroundColor: corBotao,
          color: corTexto
        }"
        class="btn"
      >
        Alterar Senha
      </button>
        <div class="form-group">
          <label :style="{color: corTexto}" for="exampleInputPassword1">Senha atual</label>
          <input
            type="password"
            class="form-control"
            id="exampleInputPassword1"
            placeholder="Senha"
            v-model="senha"
          />
        </div>
        <div class="form-group">
          <label :style="{color: corTexto}" for="exampleInputPassword1">Senha nova</label>
          <input
            type="password"
            class="form-control"
            id="exampleInputPassword1"
            placeholder="Senha"
            v-model="senhaNova"
          />
        </div>
        <div class="form-group">
          <label :style="{color: corTexto}" for="exampleInputPassword1">Confirmar senha nova</label>
          <input
            type="password"
            class="form-control"
            id="exampleInputPassword1"
            placeholder="Senha"
            v-model="senhaConfirmar"
          />
        </div>
      <div class="modal-footer">
        <button
          style="align-items: center; margin-top: 5px; margin-bottom: 5px;background-color:#006400 ;"
          class="btn btn-dark"
          @click="alterarSenha(senha, senhaNova, senhaConfirmar)"
        >
          Alterar
        </button>
      </div>
    </div>
    
  </div>
</template>
<style>
.botao {
  display: flex;
  align-items: center;
  margin-top: 5px;
  margin-bottom: 5px;
}
</style>
<script>
import Swal from "sweetalert2";
import Inis from "../services/inis";
import Usuario from "../services/usuario";
import { mapGetters } from "vuex";

export default {
  name: "AlterarSenha",
  data() {
    return {
      corFundo: "",
      corBotao: "",
      corTexto: "",
      senha: "",
      senhaNova: "",
      senhaConfirmar: "",
      usuario: [],
      logadoAux: false,
    };
  },
  computed: {
    ...mapGetters({
      //adicionais: 'allAdicionais',
      logado: "retornaLogado",
    }),
  },
  methods: {
  listarinis() {
      Inis.listarinis().then((resposta) => {
        this.inis = resposta.data;
      });
      var cd = "Cor_primaria";
      Inis.listarInisCd(cd).then(resposta => {
        this.corFundo = resposta.data[0].vl;
      });
      var cd = "Cor_secundaria";
      Inis.listarInisCd(cd).then(resposta => {
        this.corBotao = resposta.data[0].vl;
      });
      var cd = "Cor_tercearia";
      Inis.listarInisCd(cd).then(resposta => {
        this.corTexto = resposta.data[0].vl;
      });      
    },
    alterarSenha(senha, senhaNova, senhaConfirmar) {
      var email = localStorage.getItem("email" + localStorage.getItem('contrato'));
      if (senhaNova != senhaConfirmar) {
        Swal.fire({
          title: "Senhas diferentes",
          confirmButtonColor: "#000000",
        });
      } else {
        Usuario.listandoLogin(email,senha).then((resposta) => {
          if (resposta.data == null) {
            Swal.fire({
              title: "Senha atual errada",
              confirmButtonColor: "#000000",
            });
          } else {
            this.usuarios = resposta.data[0];

            var u = new Object();
            u.senhaNova = senhaNova;
            u.cd = localStorage.getItem("cd"+ localStorage.getItem('contrato'));

            Usuario.alterarusuario(u).then(function (response) {
              Swal.fire({
                title: "Senha alterada com sucesso",
                confirmButtonColor: "#000000",
              });
            });
            this.$router.push("/");
          }
        });
      }
    },
    verificaLogado() {
      if (this.logado == false) {
        this.$router.push("/login");
      }
    },
  },

  mounted() {
    this.verificaLogado();
    this.listarinis();
  },
};
</script>